<script setup lang="ts">
import type {
  JobBookingCustomer,
  JobBookingRefConfig,
} from '@/models/advancedJobBooking';

import CustomerCodeAutocompleteField from '@/components/fields/CustomerCodeAutocompleteField.vue';
import KTextField from '@/components/fields/KTextField.vue';
import PhoneInput from '@/components/inputs/PhoneInput.vue';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface Props {
  refConfigs?: [JobBookingRefConfig, JobBookingRefConfig, JobBookingRefConfig];
}

const props = withDefaults(defineProps<Props>(), {
  refConfigs: () => [
    { label: 'Reference 1', required: false },
    { label: 'Reference 2', required: false },
    { label: 'Reference 3', required: false },
  ],
});

const model = defineModel<JobBookingCustomer>({
  default: () => ({
    customer_code: null,
    caller: '',
    phone: '',
    REF1: '',
    REF2: '',
    REF3: '',
  }),
});
</script>

<template>
  <div
    :class="$style.jobBookingCustomerSection"
    data-testid="jobBookingCustomerSection"
  >
    <div :class="$style.fields">
      <CustomerCodeAutocompleteField
        v-model="model.customer_code"
        :rules="[requiredValidationRule]"
        validate-on="input"
        autofocus
      />
      <KTextField
        v-model="model.caller"
        label="Caller"
        size="md"
        :rules="[requiredValidationRule]"
        validate-on="input"
      />
      <PhoneInput v-model="model.phone" size="md" validate-on="input" />
      <KTextField
        v-model="model.REF1"
        :label="props.refConfigs[0].label"
        size="md"
        :rules="props.refConfigs[0].required ? [requiredValidationRule] : []"
        validate-on="input"
      />
      <KTextField
        v-model="model.REF2"
        :label="props.refConfigs[1].label"
        size="md"
        :rules="props.refConfigs[1].required ? [requiredValidationRule] : []"
        validate-on="input"
      />
      <KTextField
        v-model="model.REF3"
        :label="props.refConfigs[2].label"
        size="md"
        :rules="props.refConfigs[2].required ? [requiredValidationRule] : []"
        validate-on="input"
      />
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
.jobBookingCustomerSection {
}

.fields {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
</style>
